// extracted by mini-css-extract-plugin
module.exports = {"form":"CheckoutSelector__form___1DzWY"};